import { formatAddress, type ProfileResource } from '@medplum/core'
import type { Address } from '@medplum/fhirtypes'
import { TypographyDetail, TypographySubtle } from '@seen/ui'
import type { JSX } from 'react'
import { CopyButton } from '#src/components/core/CopyButton.tsx'
import { EditButton } from '#src/components/patient/detail-content/contact-tab/EditButton.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

interface AddressDisplayProps {
  address?: Address
  profile: ProfileResource
}

export function AddressDisplay({
  address,
  profile,
}: AddressDisplayProps): JSX.Element {
  const isReadOnly = useIsReadOnly()
  return (
    <div className="group flex items-center gap-1">
      <div className="grid flex-1">
        <TypographyDetail className="leading-none font-semibold text-zinc-950">
          Address
        </TypographyDetail>
        <TypographySubtle className="py-1.5">
          {address && formatAddress(address)}
          {!address && 'Unknown'}
        </TypographySubtle>
      </div>
      <div className="invisible flex group-hover:visible">
        <CopyButton
          value={address ? formatAddress(address) : undefined}
          ariaLabel="Copy address"
        />
        {!isReadOnly && <EditButton profile={profile} field="address" />}
      </div>
    </div>
  )
}
